import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';

export const validateIf = (
  conditionFn: () => Observable<boolean>,
  validators: ValidatorFn[],
) => {
  const validatorFn = Validators.compose(validators);
  let isSubscribed = false,
    lastCondition: boolean | null = null;
  return (control: AbstractControl): ValidationErrors | null => {
    if (!isSubscribed) {
      try {
        conditionFn().subscribe(value => {
          lastCondition = value;
          isSubscribed = true;
          control.updateValueAndValidity();
        });
        isSubscribed = true;
      } catch {
        return null;
      }
    }

    if (lastCondition === null) {
      return null;
    }

    return lastCondition && validatorFn ? validatorFn(control) : null;
  };
};
